import { takeLatest } from "redux-saga/effects"

import {
	HIDE_READER_REQUEST,
	SET_READER_REQUEST,
	type hideReaderRequest,
	type setReaderRequest,
} from "./actions"
import { hideReaderRequstSaga, setReaderRequestSaga } from "./sagas"

const readerSagas = [
	takeLatest(
		[SET_READER_REQUEST, HIDE_READER_REQUEST],
		function* (
			action: ReturnType<typeof setReaderRequest | typeof hideReaderRequest>
		) {
			if (action.type === SET_READER_REQUEST)
				yield* setReaderRequestSaga(action)
			else yield* hideReaderRequstSaga()
		}
	),
]

export default readerSagas
